// @flow
import React from 'react';

import { ProductTeaser } from 'Components/widgets/product-teaser/ProductTeaser.jsx';
import { SiteContainer } from 'Components/frameworks/site-container/SiteContainer.jsx';

import { getProductProps } from 'Components/widgets/product/Product.mapper';

import { type ProductSummaryDescriptorProps } from 'Client/cms/toolkit/product-summary/productSummary.resolver';

type ProducstSummaryLineProps = {
  ...$Exact<ProductSummaryDescriptorProps>,
  id?: string,
};

export function ProductSummaryLine({ id, color, config, product }: ProducstSummaryLineProps) {
  return (
    <SiteContainer id={id} className="Line">
      <ProductTeaser
        card={{
          heading: {
            iconName: product?.resortId?.toLowerCase(),
            title: product?.name,
          },
          link: { url: product?.href },
          text: { text: product?.title },
          color: color,
        }}
        product={getProductProps({ config, product })}
      />
    </SiteContainer>
  );
}
